export default {
  cptCodesList: null,
  addCptCode: null,
  deleteCptCode: null,
  cptCodeDetails: null,
  updateCptCode: null,
  service: null,
  cptCodesColumns:null,
  cptMeta:null,
}